import { useDispatch, useSelector } from "react-redux"

import {
  othersSnippets,
  pinnedSnippets,
  setPinnedOthersTabsValue,
  snippetsTabsValue,
} from "rtk-slice"

import { Badge, Box, Tab, Tabs, Typography } from "@mui/material"

const SnippetsTabs = () => {
  const dispatch = useDispatch()
  const othersSnippetsLengthState = useSelector(othersSnippets).length
  const pinnedSnippetsLengthState = useSelector(pinnedSnippets).length
  const snippetsTabsValueState = useSelector(snippetsTabsValue)

  const handleChangeSnippetsTabs = (_, newValue) => {
    dispatch(setPinnedOthersTabsValue(newValue))
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        flex: 1,
      }}
    >
      <Tabs
        onChange={handleChangeSnippetsTabs}
        variant="fullWidth"
        value={snippetsTabsValueState}
        sx={{
          pt: "1em",
          "& .MuiTabs-indicator": {
            zIndex: -1,
          },
        }}
      >
        <Tab
          value={0}
          label={
            <>
              <Badge
                badgeContent={pinnedSnippetsLengthState}
                color="error"
                sx={{
                  position: "absolute",
                  top: "20%",
                  right: "20%",
                }}
                showZero
              />
              <Typography
                variant="body1"
                sx={{
                  textAlign: "left",
                  width: "100%",
                }}
              >
                Pinned
              </Typography>
            </>
          }
          sx={{
            width: "120px",
            px: 2,
            "&.Mui-selected": {
              fontWeight: 900,
            },
          }}
          disableTouchRipple
        />
        <Tab
          value={1}
          label={
            <>
              <Badge
                badgeContent={othersSnippetsLengthState}
                color="error"
                sx={{
                  position: "absolute",
                  top: "20%",
                  right: "20%",
                }}
                showZero
              />
              <Typography
                variant="body1"
                sx={{
                  textAlign: "left",
                  width: "100%",
                }}
              >
                Others
              </Typography>
            </>
          }
          sx={{
            width: "120px",
            px: 2,
            "&.Mui-selected": {
              fontWeight: 900,
            },
          }}
          disableTouchRipple
        />
      </Tabs>
    </Box>
  )
}

export default SnippetsTabs
